export default {
    accesories_list_optional: [],
    alerts: {
        OPEX: {
            category: 'adjustable',
            is_active: false,
            is_mandatory: true,
            type: 'restrictive',
        },
        tax_incentive: {
            applicable_products: [],
            category: 'adjustable',
            is_active: false,
            is_mandatory: true,
            sim_time: 2,
            sim_unit: 'years',
            type: 'restrictive',
            value: 0.3,
        },
        supplier_annual_increase: {
            category: 'adjustable',
            is_active: false,
            is_mandatory: false,
            type: 'restrictive',
            value: 0,
            value_type: 'percentage',
        },
        supplier_VAT: {
            category: 'adjustable',
            is_active: false,
            is_mandatory: false,
            type: 'restrictive',
            value_type: 'percentage',
            value: 0,
        },
        currency_code: {
            category: 'adjustable',
            is_active: false,
            is_mandatory: false,
            type: 'restrictive',
        },
        module_equipment_required: {
            category: 'non-adjustable',
            is_active: false,
            is_mandatory: false,
            type: 'restrictive',
        },
        storage_equipment_required: {
            category: 'non-adjustable',
            is_active: false,
            is_mandatory: false,
            type: 'informative',
        },
    },
    amount_values: { isChecked: false, max: 0, min: 0 },
    catalog_documents: [],
    dealer_fee: 0,
    description: '',
    file_rate: null,
    insurance_product: '',
    inverters_list: '',
    name: '',
    panels_list: '',
    parameters: { annual_increase: 0, tax: 0, terms: [] },
    parameters_commission_credit: {
        isChecked: false,
        opening_commission_vat: 0,
        unit: 0,
        value: 0,
    },
    parameters_hitch: { isChecked: false, unit: 0, value: 0 },
    parameters_rate: { isChecked: false, value: 0 },
    power_values: { isChecked: false, max: 0, min: 0 },
    rate_list: [],
    template: '',
    type: 'public',
    type_algorithm: 'static_payment',
    types_business_company: 'physical_person',
};
